'use client';
import React, { ReactNode } from 'react';

import { ExperienceContextProvider } from '@/contexts/experienceContext';
import { ObserverContextProvider } from '@/contexts/observerContext';
import { VillageContextProvider } from '@/contexts/villageContext';
import { FilterContextProvider } from '@/contexts/filterContext';
import { GalleryProvider } from '@/hooks/useGalleryContext';
import { ChatProvider } from '@/hooks/useChatContext';
import { MapProvider } from '@/hooks/useMapContext';
import { FAQProvider } from '@/hooks/useFAQContext';
import { GlobalContextProvider } from '@/contexts/globalsContext';
import { UserContextProvider } from '@/contexts/userContext';
import { VillabookingProvider } from '@/hooks/useVillabookingContext';
import { DatePickerContextProvider } from '@/contexts/datePickerContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { CurrencyProvider } from '@/contexts/currencyContext';
import { GetMeResponse } from '@/actions/auth';

const queryClient = new QueryClient();

const Providers = ({
  children,
  identity,
  currency,
  getMeResponse,
}: {
  children: ReactNode;
  identity: string;
  currency?: 'EUR' | 'USD' | 'GBP';
  getMeResponse: GetMeResponse;
}) => {
  return (
    <QueryClientProvider client={queryClient}>
      <GlobalContextProvider>
        <UserContextProvider identity={identity} getMeResponse={getMeResponse}>
          <MapProvider>
            <ChatProvider>
              <FAQProvider>
                <GalleryProvider>
                  <FilterContextProvider>
                    <DatePickerContextProvider>
                      <VillageContextProvider>
                        <ExperienceContextProvider>
                          <ObserverContextProvider>
                            <VillabookingProvider>
                              <CurrencyProvider cookieCurrency={currency}>
                                {children}
                              </CurrencyProvider>
                            </VillabookingProvider>
                          </ObserverContextProvider>
                        </ExperienceContextProvider>
                      </VillageContextProvider>
                    </DatePickerContextProvider>
                  </FilterContextProvider>
                </GalleryProvider>
              </FAQProvider>
            </ChatProvider>
          </MapProvider>
        </UserContextProvider>
      </GlobalContextProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};

export default Providers;
